import * as React from "react"
const MailIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={18.583} {...props}>
    <g fill="#0e5492" data-name="Group 173">
      <path
        d="M23.203.001H.797a.8.8 0 0 0-.8.8v1.6a.27.27 0 0 0 .146.193L11.92 9.321a.2.2 0 0 0 .2 0l11.422-6.719c.064-.036.234-.131.3-.174s.157-.1.157-.195V.797a.8.8 0 0 0-.8-.8Z"
        data-name="Path 366"
      />
      <path
        d="M23.901 4.823a.2.2 0 0 0-.2 0l-6.465 3.8a.2.2 0 0 0-.045.307l6.464 6.968a.2.2 0 0 0 .146.064.2.2 0 0 0 .2-.2V4.992a.2.2 0 0 0-.1-.173Z"
        data-name="Path 367"
      />
      <path
        d="M15.374 9.9a.2.2 0 0 0-.247-.037l-2.591 1.524a1.011 1.011 0 0 1-1 .007l-2.28-1.3a.2.2 0 0 0-.234.027L.364 18.15a.2.2 0 0 0 .036.318.771.771 0 0 0 .4.117h22.174a.2.2 0 0 0 .146-.335Z"
        data-name="Path 368"
      />
      <path
        d="M7.117 9.169a.2.2 0 0 0-.036-.319L.297 4.975a.2.2 0 0 0-.3.173v10.168a.2.2 0 0 0 .334.146Z"
        data-name="Path 369"
      />
    </g>
  </svg>
)
export default MailIcon;
